import { css } from '@emotion/react'

// The purpose of this file is to store content agnostic styles
// to help retain consistency across cotnent channels and/or types.

// Used to override the media control position for content types
// that require the media controls to be at the top of the display.
export const mediaControlsAtTop = css({
  '.kuiper-media-control-container': {
    top: 15,
    '&.kuiper-is-hovering': {
      zIndex: 1001,
    },
  },
})
